const appendQueryParams = (endpoint, params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    searchParams.append(key, value);
  });
  const separator = endpoint.includes('?') ? '&' : '?';
  const queryString = searchParams.toString();
  return queryString ? `${endpoint}${separator}${queryString}` : endpoint;
};

export const fetchPaginatedCollection = async (
  api,
  endpoint,
  { pageSize = 500, maxPages = 100, maxRecords = 50000, params = {} } = {}
) => {
  const records = [];
  let page = 1;
  let hasNextPage = true;

  while (hasNextPage && page <= maxPages && records.length < maxRecords) {
    const url = appendQueryParams(endpoint, {
      ...params,
      page,
      page_size: pageSize,
    });
    const res = await api.get(url);
    const payload = res.data;

    if (Array.isArray(payload)) {
      return payload;
    }

    const pageResults = Array.isArray(payload?.results) ? payload.results : [];
    if (!pageResults.length) break;

    records.push(...pageResults);
    hasNextPage = Boolean(payload?.next);
    page += 1;
  }

  return records.slice(0, maxRecords);
};
